import dayjs from 'dayjs';

import { getPresentDateRange } from 'timeline/utils/getPresentDateRange';
import { getFutureDateRange } from 'timeline/utils/getFutureDateRange';
import { localizeDate } from 'shared/utils/localizeDate';

/**
 * [getUpcomingReleasesDateRange] Upcoming Releases sort has an implicit release_date filter
 * of tomorrow to 1 year from tomorrow. This helper function gets `tmr - 1 year from tomorrow` date range
 * @param asPath ex: '/search', '/brand/air-jordan', '/timeline', '/timeline/future'
 */

export const getUpcomingReleasesDateRange = (asPath = null) => {
  const pathnameWithDynamicValuesIncluded: string = asPath?.split('?')?.[0];

  if (pathnameWithDynamicValuesIncluded === '/timeline') {
    return {
      min: dayjs().startOf('day').add(1, 'day').format(localizeDate('YYYYMMDD')),
      max: getPresentDateRange().max,
    };
  }

  if (pathnameWithDynamicValuesIncluded === '/timeline/future') {
    return {
      min: getFutureDateRange().min,
      max: getFutureDateRange().max,
    };
  }

  return {
    min: dayjs().startOf('day').add(1, 'day').format(localizeDate('YYYYMMDD')),
    max: dayjs().startOf('day').add(1, 'day').add(1, 'year').format(localizeDate('YYYYMMDD')),
  };
};
